import { action, observable } from 'mobx';

import { Paginated } from '../../adl-gen/common';
import { DbKey, WithDbId } from '../../adl-gen/common/db';
import { TableQuery } from '../../adl-gen/common/tabular';
import { LearningProvider, LearningProviderCatalogEntry } from '../../adl-gen/totalinteraction/futurefit/db';
import { Catalog, CatalogResp } from '../../adl-gen/totalinteraction/futurefit/lpapi';
import { Service } from '../../service/service';
import { LoggedIn, LoggedInSuper } from '../../stores/identity-store';

import { DataStore, TransportLayer } from './datastore';

class LearningProviderCatalogApi implements TransportLayer<LearningProviderCatalogEntry> {
  kind: string = 'LearningProviderCatalog';
  constructor(protected readonly service: Service) {}
  create = async (item: LearningProviderCatalogEntry): Promise<DbKey<LearningProviderCatalogEntry>> =>
    this.service.createLearningProviderCatalogEntry(item);
  update = async (itemWithId: WithDbId<LearningProviderCatalogEntry>): Promise<void> =>
    this.service.updateLearningProviderCatalogEntry(itemWithId);
  doDelete = async (id: DbKey<LearningProviderCatalogEntry>): Promise<void> =>
    this.service.deleteLearningProviderCatalogEntry(id);
  query = async (q: TableQuery): Promise<Paginated<WithDbId<LearningProviderCatalogEntry>>> =>
    this.service.queryLearningProviderCatalogEntries(q);

  onRefresh = async (learningProvider: DbKey<LearningProvider>): Promise<CatalogResp> =>
    this.service.queryLearningProviderCatalog(learningProvider);
  // onRefresh = async (endpoint: EndPoint, username: string, authKey: string): Promise<Catalog> => this.service.lp_GetCatalog(endpoint, username, authKey);
}

export class LearningProviderCatalogStore extends DataStore<LearningProviderCatalogEntry> {
  @observable selectedLearningProvider?: WithDbId<LearningProvider>;

  static fromService = (
    service: Service,
    identity: LoggedIn | LoggedInSuper,
    id?: DbKey<LearningProviderCatalogEntry>
  ): LearningProviderCatalogStore => {
    const store = new LearningProviderCatalogStore(new LearningProviderCatalogApi(service), identity, id);
    return store;
  };

  // Load for a specific LearningProvider
  load = async (lpId?: DbKey<LearningProvider>): Promise<Paginated<WithDbId<LearningProviderCatalogEntry>>> => {
    if (this.isSuperUser) {
      return lpId ? this.transport.query(this.queryId(lpId, 'providerId')) : this.transport.query(this.queryAll);
    }
    return Promise.reject('Not authorized');
  };

  @action
  setLearningProviderFilter = (lp: WithDbId<LearningProvider>) => {
    this.selectedLearningProvider = lp;
    // Don't call reload()
    this.data = this.load(lp.id);
  };

  /// Fetch catalog from learning provider
  onRefresh = async (learningProvider: DbKey<LearningProvider>): Promise<Catalog> => {
    if (this.isSuperUser) {
      const lpResult = await (this.transport as LearningProviderCatalogApi).onRefresh(learningProvider);
      if (lpResult.kind === 'errorResponse') {
        return Promise.reject(
          `Could not refresh catalog for provider: Response code ${lpResult.value.code} Error message ${lpResult.value.error}`
        );
      } else {
        const catalog = lpResult.value;
        return catalog;
      }
    }
    return Promise.reject('Not authorized');
  };
}



// WEBPACK FOOTER //
// ./src/admin/stores/learning-provider-catalog-store.ts